export const CODEC_OPTIONS = ['UTF-8', 'SHIFT-JIS']

export const PER_PAGE_OPTIONS = [30, 50, 100]
